import { useEffect, useState, useCallback } from "react";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { ClockHistory } from "react-bootstrap-icons";
import notify from "../../common/ui/notify";
import PageHero from "../../common/ui/PageHero";
import { LoadingBlock, EmptyBlock } from "../../common/ui/StateBlock";
import { formatPrice, carTitle } from "../../common/format";
import { resultInfo, thumbStyle } from "./myShared";
import { t } from "./auctionI18n";
import "./Auction.css";
import "../../common/ui/ui.css";

const FILTERS = [
    { key: "all",    label: () => t("ყველა", "All", "Все", "Բոլորը") },
    { key: "active", label: () => t("აქტიური", "Active", "Активные", "Ակտիվ") },
    { key: "won",    label: () => t("მოგებული", "Won", "Выиграно", "Շահած") },
    { key: "lost",   label: () => t("წაგებული", "Lost", "Проиграно", "Պարտված") },
];

const matchFilter = (b, f) => {
    if (f === "all") return true;
    if (f === "active") return b.result === "leading" || b.result === "outbid";
    if (f === "won") return b.result === "won";
    if (f === "lost") return b.result === "lost" || b.result === "pending" || b.result === "countered";
    return true;
};

const AuctionBids = () => {
    const history = useHistory();
    const [bids, setBids] = useState(null);
    const [filter, setFilter] = useState("all");

    const load = useCallback(async () => {
        try {
            const res = await axios.get("/api/auction/my/activity");
            setBids(res.data.bid_history || []);
        } catch (err) {
            if (err && err.response && err.response.status === 401) { history.replace("/auction/login"); return; }
            notify.apiError(err);
            setBids([]);
        }
    }, [history]);

    useEffect(() => { load(); }, [load]);

    if (bids === null) return <div className="container auction-narrow"><LoadingBlock label={t("იტვირთება...", "Loading...", "Загрузка...", "Բեռնվում է...")} /></div>;

    const shown = bids.filter((b) => matchFilter(b, filter));

    return (
        <>
            <PageHero eyebrow="Carexpress" title={t("ბიდების ისტორია", "Bid history", "История ставок", "Հայտերի պատմություն")} subtitle={t("ყველა ლოტი, რომელზეც ბიდი დადეთ, შედეგით.", "Every lot you bid on, with the result.", "Все лоты, на которые вы ставили, с результатом.", "Բոլոր լոտերը, որոնց վրա հայտ եք դրել՝ արդյունքով։")} />
            <div className="container auction-narrow auction-wide auction-my">
                <Link to="/auction/my" className="auction-back">← {t("ჩემი აუქციონები", "My auctions", "Мои аукционы", "Իմ աճուրդները")}</Link>

                {bids.length === 0 ? (
                    <EmptyBlock title={t("ბიდები არ არის", "No bids", "Нет ставок", "Հայտեր չկան")} message={t("ჯერ არცერთ ლოტზე არ დაგიდიათ ბიდი.", "You have not bid on any lot yet.", "Вы ещё не делали ставок ни на один лот.", "Դուք դեռ ոչ մի լոտի վրա հայտ չեք դրել։")}
                        action={<Link to="/auctions" className="cx-btn cx-btn-primary">{t("აუქციონები", "Auctions", "Аукционы", "Աճուրդներ")}</Link>} />
                ) : (
                    <>
                        <div className="auction-filterbar">
                            {FILTERS.map((f) => (
                                <button key={f.key} className={`auction-filter ${filter === f.key ? "is-active" : ""}`} onClick={() => setFilter(f.key)}>
                                    {f.label()}
                                </button>
                            ))}
                        </div>

                        <section className="cx-card auction-my-section">
                            <h3><ClockHistory className="auction-sec-ico" /> {t("ბიდები", "Bids", "Ставки", "Հայտեր")} ({shown.length})</h3>
                            {shown.length === 0 ? (
                                <p className="auction-muted" style={{ padding: "8px 0" }}>{t("ამ ფილტრით ჩანაწერი არ მოიძებნა.", "No records match this filter.", "По этому фильтру записей нет.", "Այս ֆիլտրով գրառում չգտնվեց։")}</p>
                            ) : (
                                <div className="auction-my-list">
                                    {shown.map((b) => {
                                        const r = resultInfo(b.result);
                                        const active = b.status === "open" || b.status === "live";
                                        const Row = (
                                            <>
                                                <div className="auction-my-thumb" style={thumbStyle(b.images)} />
                                                <div className="auction-my-main">
                                                    <strong>{carTitle(b)}</strong>
                                                    <span className="auction-muted">
                                                        {t("ჩემი ბიდი", "My bid", "Моя ставка", "Իմ հայտը")} {formatPrice(b.my_bid, "GEL")}
                                                        {b.my_max != null && <> · {t("მაქს.", "Max", "Макс.", "Առավ.")} {formatPrice(b.my_max, "GEL")}</>}
                                                    </span>
                                                </div>
                                                <div className="auction-my-row-right">
                                                    <span>{formatPrice(b.current_price, "GEL")}</span>
                                                    <span className={`auction-result ${r.cls}`}>{r.label}</span>
                                                </div>
                                            </>
                                        );
                                        return active
                                            ? <Link to={`/auction/lot/${b.lot_id}`} key={b.lot_id} className="auction-my-row">{Row}</Link>
                                            : <div key={b.lot_id} className="auction-my-row">{Row}</div>;
                                    })}
                                </div>
                            )}
                        </section>
                    </>
                )}
            </div>
        </>
    );
};

export default AuctionBids;
